import { CANCEL_POLICY_MODAL } from '.';
import { PolicyRequest } from '../policy-create';
import {
  CANCEL_POLICY_START,
  CANCEL_POLICY_SUCCESS,
  CANCEL_POLICY_FAILED,
  PolicyCancelStore,
  CANCEL_POLICY_REASON
} from './types';

export const cancelPolicy = (
  state: PolicyCancelStore = {
    cancelPending: false,
    showRefund: false,
    cancellationReason: undefined,
  },
  action: {
    type: string;
    payload?: PolicyRequest | boolean | string;
  }
): PolicyCancelStore => {
  switch (action.type) {
    case CANCEL_POLICY_START:
      return { ...state, error: undefined, response: undefined, cancelPending: true };
    case CANCEL_POLICY_REASON: {
      return {
        ...state,
        cancellationReason: action.payload as string
      };
    }
    case CANCEL_POLICY_SUCCESS: {
      return {
        ...state,
        cancelPending: false,
        response: action.payload as PolicyRequest,
        error: undefined
      };
    }
    case CANCEL_POLICY_FAILED: {
      return {
        ...state,
        cancelPending: false,
        error: action.payload,
        response: undefined
      };
    }
    case CANCEL_POLICY_MODAL: {
      return {
        ...state,
        showRefund: action.payload as boolean,
        cancellationReason: undefined,
        error: undefined,
        response: undefined
      };
    }
    default:
      return state;
  }
};
